import Button from '@components/button';
import Popup from '@components/popup';

interface IConfirmationPopup {
  className?: string;
  title: string;
  text?: string;
  buttonText: string;
  isPopupActionLoading: boolean;
  onClose: () => void;
  onConfirm: Function;
}

const ConfirmationPopup = (props: IConfirmationPopup) => {
  const { title, text, buttonText, isPopupActionLoading, onClose, onConfirm, className } = props;

  const handleClose = () => {
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Popup className={className} size="small" onClose={handleClose}>
      <Popup.Header>{title}</Popup.Header>

      {Boolean(text) && <Popup.Content>{text}</Popup.Content>}

      <Popup.Footer>
        <Popup.ActionWrapper type="main">
          <Button
            disabled={isPopupActionLoading}
            loading={isPopupActionLoading}
            theme="primary"
            onClick={handleConfirm}
          >
            {buttonText}
          </Button>
        </Popup.ActionWrapper>
      </Popup.Footer>
    </Popup>
  );
};

export { ConfirmationPopup };
